import { ReferenceParser } from "@methodset/calculator-ts";
import { DividerWidgetConfiguration, Widget } from '@methodset/application-client-ts';

export class DividerWidgetSync {

    public static parser = (widget: Widget): string[] => {
        const configuration = widget.configuration as DividerWidgetConfiguration;
        const refs: string[] = [];
        refs.push(...ReferenceParser.extract(configuration.hideId, true));
        refs.push(...ReferenceParser.extract(configuration.title));
        return refs;
    }

    public static updater = (widget: Widget, target: string, replacement: string): void => {
        const configuration = widget.configuration as DividerWidgetConfiguration;
        configuration.hideId = ReferenceParser.update(configuration.hideId, target, replacement, true);
        configuration.title = ReferenceParser.update(configuration.title, target, replacement);
    }

}
